import { TableConfig } from '@shared/interfaces/table/table-config';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import {DecimalCellComponent} from '@shared/components/table/cells/decimal-cell/decimal-cell.component';
import {DATE_TIME_FORMAT} from '@app/core/constants/date-time-format';

export const usedVerificationMeterReadingsTable: TableConfig<any> = {
  exportable: true,
  pagination: true,
  pageSize: 50,
  oData: true,
  columns: [
    {
      title: 'dashboard.timeseries.meterreadingts',
      key: 'meterReadingTs',
      width: 150,
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT,
      }
    },
    {
      title: 'dashboard.timeseries.missing.meteringpointid',
      key: 'meteringPointIdentification',
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/meteringpoint',
        urlReference: 'meteringPointIdentification',
      }
    },
    {
      title: 'dashboard.timeseries.missing.meterreadingoccurrence',
      key: 'resolution',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        'notspecified': 'enum.resolution.notspecified',
        'year': 'enum.resolution.year',
        'month': 'enum.resolution.month',
        'day': 'enum.resolution.day',
        'hour': 'enum.resolution.hour',
        'quarter': 'enum.resolution.quarter',
      }
    },
    {
      title: 'dashboard.timeseries.meterreadingvalue',
      key: 'meterReadingValue',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: {
        decimals: 3,
      }
    }
  ],
}
